import styled from 'styled-components';

export const Wrapper = styled.div<{ isDisabled: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: ${({ theme, isDisabled }) => (isDisabled ? theme.colors.black4 : theme.colors.black9)};
`;
